module.exports = __webpack_public_path__ + "img/logo-square-icon.13950e1a.svg";